import { CaptureValueType } from '../../enum';

export class CaptureSettingsMerchantTreeDto {
  id: number;
  parentId?: number;
  key: string;
  name: string;
  description?: string;
  valueType: CaptureValueType;
  defaultValue: string;
  merchantSettingValue: string;
  merchantSettingId: number;
  level: number;
  sequence: number;
  children?: CaptureSettingsMerchantTreeDto[];
  createdDate?: Date;
  modifiedDate?: Date;
  lastModifiedUserId?: number;
  version?: number;
}